import { Plus, X } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export function TrainingLinksInput({
  value,
  onChange,
}: {
  value: string[];
  onChange: (links: string[]) => void;
}) {
  return (
    <fieldset className="grid gap-3">
      <legend className="mb-2 text-sm font-medium">Training links</legend>
      {value.map((link, index) => (
        <div key={index} className="grid gap-2">
          <Label htmlFor={`training-link-${index}`}>Link {index + 1}</Label>
          <div className="flex gap-2">
            <Input
              id={`training-link-${index}`}
              required
              type="url"
              maxLength={2048}
              value={link}
              placeholder="https://…"
              onChange={(event) =>
                onChange(
                  value.map((item, position) =>
                    position === index ? event.target.value : item,
                  ),
                )
              }
            />
            {value.length > 1 && (
              <Button
                type="button"
                variant="ghost"
                size="icon"
                aria-label={`Remove link ${index + 1}`}
                onClick={() =>
                  onChange(value.filter((_, position) => position !== index))
                }
              >
                <X className="h-4 w-4" />
              </Button>
            )}
          </div>
        </div>
      ))}
      <Button
        type="button"
        variant="outline"
        className="w-fit"
        disabled={value.length >= 20}
        onClick={() => onChange([...value, ""])}
      >
        <Plus className="h-4 w-4" />
        Add another link
      </Button>
      <p className="text-xs text-muted-foreground">
        Up to 20 links per course.
      </p>
    </fieldset>
  );
}
